import Axios from "axios"
import { goRiceUrl } from "../../constant/siteConstants"
import api from "../../services/api-configuration"


export const login = (userInfo, password) => {
    let user = { userInfo, password }
    return Axios.post(`${goRiceUrl}/api/login`, user)
}

export const loginArizaQr = (username, password) => {
    let user = { "Email": username, "Password": password }
    return Axios.post(`${goRiceUrl}/auth-token`, user)
}

const safeBase64Decode = (key) => {
    try {
        const value = localStorage.getItem(key);
        if (!value) return null;
        return Buffer.from(value, 'base64').toString('ascii');
    } catch (error) {
        console.error(`Error decoding ${key}:`, error);
        return null;
    }
};

export const changePass = (username, password, current) => {
    const employee_id = safeBase64Decode("employee_id");
    const user_id = safeBase64Decode("employee_id");

    if (!employee_id || !user_id) {
        return Promise.reject(new Error("Missing or invalid user credentials"));
    }

    const result = {
        employee_id: parseInt(employee_id),
        new_password: password,
        old_password: current,
        user_id: parseInt(user_id)
    };

    return api.post(`/changePassword`, result);
};


export function checkPassword(password, setter, passwordCheck) {
    let result = true
    let rule = {}
    // Parolanın en az 8 karakter uzunluğunda olması gerektiğini kontrol et
    if (password?.length < 8) {
        rule["Parola en az 8 karakter uzunluğunda olmalıdır."] = false
        result = false

    } else {
        rule["Parola en az 8 karakter uzunluğunda olmalıdır."] = true
    }
    // Parolanın en az bir büyük harf içermesi gerektiğini kontrol et
    if (!/[A-Z]/.test(password)) {
        result = false
        rule["Parola en az bir büyük harf içermelidir."] = false

    } else rule["Parola en az bir büyük harf içermelidir."] = true
    // Parolanın en az bir küçük harf içermesi gerektiğini kontrol et
    if (!/[a-z]/.test(password)) {
        result = false
        rule["Parola en az bir küçük harf içermelidir."] = false

    } else rule["Parola en az bir küçük harf içermelidir."] = true
    // Parolanın en az bir rakam içermesi gerektiğini kontrol et
    if (!/\d/.test(password)) {
        result = false
        rule["Parola en az bir rakam içermelidir."] = false

    } else rule["Parola en az bir rakam içermelidir."] = true

    // Parolanın en az bir özel karakter içermesi gerektiğini kontrol et
    if (!/[^A-Za-z0-9]/.test(password)) {
        result = false
        rule["Parola en az bir özel karakter içermelidir."] = false

    } else rule["Parola en az bir özel karakter içermelidir."] = true

    if (setter) {
        setter(rule)
    }
    if (passwordCheck) {
        passwordCheck(Object.values(rule).filter((item) => item === false).length > 0 ? false : true)
    }


    return result;
}